import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ThorHammertimeView} from "./ThorHammertimeView";
import {ThorRespinNudgeReelController} from "../../reel/nudgereel/ThorRespinNudgeReelController";


/**
 * Created by Jerker Nord on 2019-04-11.
 */

export class ThorHammertimeController extends BeforeSpinStopPresentationController {

    private _hammertimeView:ThorHammertimeView;

    constructor(index:number) {
        super(index, "ThorHammertimeController");
        this._hammertimeView = new ThorHammertimeView();
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        return data.hammerTimeTriggered;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 4 : 5.5;
    }

    protected startPresentation(timeline:TimelineLite):void {
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : "HAMMERTIME"})), "+=1");
        timeline.add(()=>this._hammertimeView.getShowHammertimeTL());
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRespinNudgeReelController.ENABLE_LIT_SYMBOL, "M1")), "-=1.2");
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            this._hammertimeView.abort();
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}